import { ClinicalStaffService } from './clinical-staff.service';
import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs/Subscription';
import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-clinical-staff',
  templateUrl: './clinical-staff.component.html',
  styleUrls: ['./clinical-staff.component.less'],
  encapsulation: ViewEncapsulation.None
})
export class ClinicalStaffComponent implements OnInit, OnDestroy {

	public data: object = {};
	private inscription: Subscription;

    constructor(private _service: ClinicalStaffService, private _titleService: Title, private _meta: Meta) {
		this._titleService.setTitle( 'Corpo Clínico - Hospital Veterinário Stolf');
    }

	ngOnInit() {
		this._meta.addTag({
			name: 'title',
			content: 'Corpo Clínico - Hospital Veterinário Stolf - Lages SC'
		});
		this._meta.addTag({
			name: 'description',
			content: 'O Hospital Veterinário Stolf conta com um corpo clínico diverso e com vasto conhecimento nas diversas áreas da Medicina Veterinária, possibilitando o diagnóstico e tratamento de diversas enfermidades e buscando a saúde e bem estar dos animais de estimação'
		});
		this.inscription = this._service.listAll()
		.subscribe(
			response => {
				this.data['itens'] = response;
			},
			error => {
				console.error ( error );
			}
		);
	}

	lineEnter(t) {
		return t.replace(/(\r\n|\n|\r)/gm, '\n');
	}

  ngOnDestroy() {
	  this.inscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /Users/henriquezanini/Sites/Cães e Gatos/site/src/app/clinical-staff/clinical-staff.component.ts